module.exports = __webpack_public_path__ + "images/redux.30064ad2.webp";